import StockView from "./StockView";
export default StockView;